
/**
 * @fileOverview BackdropView View Module File
 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/BackdropView',['require','jquery'],function (require) {
        var $ = require('jquery');


        /**
         * Description
         *
         * @name BackdropView
         * @class BackdropView initializes and sets up a backdrop for use with the sub nav menu, can be extended to support
         * modals and other similar tasks.
         * @param customeCallback {Function} a custom callback to fire when the Backdrop is clicked
         * @constructor
         *
         * @since 1.0
         */
        var BackdropView = function (customCallback, options) {
            this.customCallback = customCallback || function () {};
            this.backdropActiveClass = options.backdropActiveClass || 'MMM--backdrop_isActive';
            this.bodyShift = options.bodyShift || 'true';
            this.init();
        };

        /**
         * Initializes the object
         *
         * @since 1.0
         */
        BackdropView.prototype.init = function () {

            return this.createChildren()
                .layout()
                .setupHandlers()
                .enable();
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.setupHandlers = function () {
            var self = this;
            var isCancellingClick = false;

            this.$targetElement.on('click', function (e) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                else {
                    //needed for IE Support
                    e.returnValue = false;
                }

                if (isCancellingClick) {
                    isCancellingClick = false;
                    return;
                }
                if (self.isEnabled === false) {
                    return;
                } else {
                    self.customCallback();
                }

            });

            return this;
        };

        /**
         * Create any child objects or references to DOM elements, also inserts hte target element into the dom if it does
         * not already exist.
         * Should only be run on initialization of the view
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.createChildren = function () {
            this.isEnabled = false;
            this.targetElementId = 'js-backdrop';
            this.$targetElement = undefined;
            this.$contentWrapper = $('#js-bodyWrapper');
            this.$menuWrapper = $('#js-mobileMenuWrapper');
            return this;
        };


        /**
         * Appends the target element to the body.
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.layout = function () {
            var $targetElement = $('#' + this.targetElementId);
            if ($targetElement.length === 0) {
                this.$targetElement = $('<div class="MMM--backdrop" id="' + this.targetElementId + '"></div>');
                this.$targetElement.appendTo('body');
            } else {
                this.$targetElement = $targetElement;
            }
            return this;
        };

        /**
         * Shows the backdrop
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.show = function () {
            if (this.isEnabled) {
                this.$targetElement.addClass(this.backdropActiveClass);
                if (this.bodyShift === true) {
                    this.$contentWrapper.addClass('js-isFixed');
                    this.$menuWrapper.addClass('js-isActive');
                }
            }
            return this;
        };

        /**
         * Hides the backdrop
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.hide = function () {
            var self = this;
            if (this.$targetElement !== undefined) {
                this.$targetElement.removeClass(this.backdropActiveClass);
                if (this.bodyShift === true) {
                    this.$contentWrapper.css({'left' : 0, 'position' : 'absolute', 'top' : 0});
                    $('body').css({'height': '100%'});
                    setTimeout(function() {
                        self.$contentWrapper.removeClass('js-isFixed');
                        self.$menuWrapper.removeClass('js-isActive');
                        self.$contentWrapper.attr('style', '');
                        $('body').attr('style', '');
                    }, 1500);

                }
            }
            return this;
        };

        /**
         * Enables the view
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            // Setup any event handlers

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.hide();
            this.isEnabled = false;

            // Tear down any event handlers

            return this;
        };

        /**
         * Disables the view, removes the target element from the DOM
         *
         * @returns {BackdropView}
         * @since 1.0
         */
        BackdropView.prototype.destroy = function () {
            this.disable();

            this.$targetElement.remove();

            return this;
        };

        return BackdropView;
    });

}(MMMRequire));


